setTimeout(() => {
    const btnRegister = document.querySelector(".cf-next-step");
    const inputReferred = document.getElementById('380631');
  
    btnRegister.disabled = true;
    btnRegister.style.display = "none";

  
    // Crear y añadir el botón de validar dinámicamente
    const validateButton = document.createElement('button');
    validateButton.textContent = 'Validar';
    validateButton.id = 'validateButton';
    validateButton.className = 'cf-cancel cf-button btn button'; // Cambiar a className
    inputReferred.insertAdjacentElement('afterend', validateButton);



    // Añadir el evento de click al botón de validar
    validateButton.addEventListener('click', function() {
        const inputValue = inputReferred.value;

        if (inputValue === '') {
            alert('El campo "Codigo de referido vip" está vacío');
        } else {
            fetch('https://versailles.koud.cloud/api/validate-code', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ code: inputValue })
            })
            .then(response => response.json())
            .then(data => {
                console.log(data);
                if (data.code === 'valid') {
                    // Código válido
                    console.log('Código válido');
                    btnRegister.style.setProperty("display", "inline", "important");
                     validateButton.style.display = "none"; 
                  btnRegister.disabled = false;
                   
                } else {
                    alert('El código referido no es válido.');
                    console.log('Código no válido');
                   
                }
            })
            .catch(error => console.error('Error:', error));
        }
    });
}, 1000);